import Button from "../button/Button";
import React, {useState} from "react";
import {useLanguage} from "../../hooks/LanguageContext";
import WarningAlert from "../common/WarningAlert";

const SenderAndReceiverInfoStep2 = ({ data, errors, handleBack, handleNext, handleInputChange }) => {
    const { direction, language } = useLanguage();
    const [disableRecepientInputs,setDisableRecepientInputs] = useState(data.sameAsRecipient);
    const handleChekbox = (e) => {
        setDisableRecepientInputs(e.target.checked);
        handleInputChange({ target: { name: "sameAsRecipient", value: e.target.checked } })
    }

    return (
        <div className="flex flex-col justify-center   space-y-6 mt-12 ">
            <div className="flex justify-around sm:justify-center gap-2 md:gap-4 lg:gap-16">
                {/* Shipper Name */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700   md:text-xl !font-bold whitespace-nowrap">اسم الشاحن</span>
                    </div>
                    <input
                        name="shipperName"
                        value={data.shipperName}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="اسم الشاحن"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px]"
                    />
                </div>

                {/* Shipper ID */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 md:text-xl !font-bold whitespace-nowrap">رقم هوية الشاحن</span>
                    </div>
                    <input
                        name="shipperId"
                        value={data.shipperId}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="رقم هوية الشاحن"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px]"
                    />
                </div>

                {/* Shipper Phone */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 md:text-xl !font-bold whitespace-nowrap">رقم الجوال الشاحن</span>
                    </div>
                    <input
                        name="shipperPhone"
                        value={data.shipperPhone}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="رقم الجوال الشاحن"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px]"
                    />
                </div>
            </div>

            {/* Checkbox: Same as Recipient */}
            <div className="flex items-center justify-start  gap-4 2xl:mr-16">
                <label className="text-grayscale-700 text-sm md:text-xl !font-bold whitespace-nowrap">
                    {language === "ar" ? "هل بيانات الشاحن نفس بيانات المستلم ⸮" : "Is the shipper's information the same as the recipient's ?"}
                </label>
                <input
                    type="checkbox"
                    name="sameAsRecipient"
                    checked={data.sameAsRecipient}
                    onChange={handleChekbox}
                    className="w-4 h-4 text-primary-700 border-gray-300 rounded cursor-pointer"
                />
            </div>

            <div className="flex justify-around sm:justify-center gap-2 md:gap-4 lg:gap-16">
                {/* Recipient Name */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 md:text-xl !font-bold whitespace-nowrap">اسم المستلم</span>
                    </div>
                    <input
                        name="recipientName"
                        value={data.recipientName}
                        onChange={handleInputChange}
                        disabled={disableRecepientInputs}
                        type="text"
                        placeholder="اسم المستلم"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px] disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed disabled:border-gray-400"
                    />
                </div>

                {/* Recipient ID */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 md:text-xl !font-bold whitespace-nowrap">رقم هوية المستلم</span>
                    </div>
                    <input
                        name="recipientId"
                        value={data.recipientId}
                        onChange={handleInputChange}
                        disabled={disableRecepientInputs}
                        type="text"
                        placeholder="رقم هوية المستلم"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px] disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed disabled:border-gray-400"
                    />
                </div>

                {/* Recipient Phone */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 md:text-xl !font-bold whitespace-nowrap">رقم جوال المستلم</span>
                    </div>
                    <input
                        name="recipientPhone"
                        value={data.recipientPhone}
                        onChange={handleInputChange}
                        disabled={disableRecepientInputs}
                        type="text"
                        placeholder="رقم جوال المستلم"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px] disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed disabled:border-gray-400"
                    />
                </div>
            </div>

                <WarningAlert alert="مالك السيارة  او المستخدم الفعلي   يجب ان يكون  طرف  يشحن السيارة او يستلمها." />

            {/* Navigation Buttons */}
            <div className="flex justify-between !mt-12">
                <Button onClick={handleBack}>السابق</Button>
                <Button onClick={handleNext}>التالي</Button>
            </div>
        </div>
    );
};

export default SenderAndReceiverInfoStep2;
